/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

const bytesInKilobyte = 1024;
const bytesInMegabyte = bytesInKilobyte * bytesInKilobyte;
const bytesInGigabyte = bytesInKilobyte * bytesInMegabyte;
const bytesInTerabyte = bytesInKilobyte * bytesInGigabyte;

export enum FileSizeUnitsInBytes {
    KB = bytesInKilobyte,
    MB = bytesInMegabyte,
    GB = bytesInGigabyte,
    TB = bytesInTerabyte,
}
